import createWsAction from 'utils/create-ws-action'

// ------------------------------------
// Action Types
// ------------------------------------
export const LIVEVISIT_LIST = 'unifi.LIVEVISIT_LIST'
export const LIVEVISIT_LIST_DATE = 'unifi.LIVEVISIT_LIST_DATE'
export const LIVEVISIT_HOLDERS_COUNT = 'unifi.LIVEVISIT_HOLDERS_COUNT'
export const LIVEVISIT_HOLDERS_COUNT_ONSITE = 'unifi.LIVEVISIT_HOLDERS_COUNT_ONSITE'

// ------------------------------------
// Action Creators
// ------------------------------------
export const listLiveVisits = createWsAction({
    type: LIVEVISIT_LIST,
    messageType: 'core.live-visit.list-site-live-visits-holder-info',
    selectorKey: 'livevisitList',
    fields: ['clientId', 'siteId']
})

export const listLiveVisitsDate = createWsAction({
    type: LIVEVISIT_LIST_DATE,
    messageType: 'core.live-visit.list-site-live-visits-holder-info-date',
    selectorKey: 'livevisitListDate',
    fields: ['clientId', 'siteId', 'startTime', 'endTime', 'limit', 'offset']
})

export const getHoldersCount = createWsAction({
	type: LIVEVISIT_HOLDERS_COUNT,
	messageType: 'core.live-visit.get-holders-count',
	selectorKey: 'liveVisitHoldersCountList',
	fields: ['clientId', 'siteId', 'startTime', 'endTime'],
});

export const getHoldersCountOnSite = createWsAction({
	type: LIVEVISIT_HOLDERS_COUNT_ONSITE,
	messageType: 'core.live-visit.get-holders-count-on-site',
	selectorKey: 'liveVisitHoldersOnSiteCountList',
	fields: ['clientId', 'siteId', 'startTime',],
});

export default null



// WEBPACK FOOTER //
// ./src/redux/modules/model/livevisit.js